import { render, staticRenderFns } from "./packageSelector.vue?vue&type=template&id=7455a6cb&scoped=true"
import script from "./packageSelector.vue?vue&type=script&lang=ts"
export * from "./packageSelector.vue?vue&type=script&lang=ts"
import style0 from "./packageSelector.vue?vue&type=style&index=0&id=7455a6cb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7455a6cb",
  null
  
)

export default component.exports